__turbopack_context__.v({
  "at": "sportstrip-module-scss-module__tXyCYa__at",
  "audioIcon": "sportstrip-module-scss-module__tXyCYa__audioIcon",
  "channel": "sportstrip-module-scss-module__tXyCYa__channel",
  "container": "sportstrip-module-scss-module__tXyCYa__container",
  "content": "sportstrip-module-scss-module__tXyCYa__content",
  "contentSection": "sportstrip-module-scss-module__tXyCYa__contentSection",
  "details": "sportstrip-module-scss-module__tXyCYa__details",
  "detailsBody": "sportstrip-module-scss-module__tXyCYa__detailsBody",
  "driver": "sportstrip-module-scss-module__tXyCYa__driver",
  "driverHeader": "sportstrip-module-scss-module__tXyCYa__driverHeader",
  "driverStripContainer": "sportstrip-module-scss-module__tXyCYa__driverStripContainer",
  "driversStrip": "sportstrip-module-scss-module__tXyCYa__driversStrip",
  "eyebrowLink": "sportstrip-module-scss-module__tXyCYa__eyebrowLink",
  "focusContainer": "sportstrip-module-scss-module__tXyCYa__focusContainer",
  "fullWidth": "sportstrip-module-scss-module__tXyCYa__fullWidth",
  "hasSubStrip": "sportstrip-module-scss-module__tXyCYa__hasSubStrip",
  "hoverStyles": "sportstrip-module-scss-module__tXyCYa__hoverStyles",
  "isLive": "sportstrip-module-scss-module__tXyCYa__isLive",
  "kebab": "sportstrip-module-scss-module__tXyCYa__kebab",
  "league": "sportstrip-module-scss-module__tXyCYa__league",
  "leagueDetails": "sportstrip-module-scss-module__tXyCYa__leagueDetails",
  "leagueLogo": "sportstrip-module-scss-module__tXyCYa__leagueLogo",
  "listenLive": "sportstrip-module-scss-module__tXyCYa__listenLive",
  "listenLiveIcon": "sportstrip-module-scss-module__tXyCYa__listenLiveIcon",
  "listenLiveLabel": "sportstrip-module-scss-module__tXyCYa__listenLiveLabel",
  "locationText": "sportstrip-module-scss-module__tXyCYa__locationText",
  "menu": "sportstrip-module-scss-module__tXyCYa__menu",
  "moreInfo": "sportstrip-module-scss-module__tXyCYa__moreInfo",
  "moreInfoActive": "sportstrip-module-scss-module__tXyCYa__moreInfoActive",
  "moreInfoButton": "sportstrip-module-scss-module__tXyCYa__moreInfoButton",
  "moreInfoContent": "sportstrip-module-scss-module__tXyCYa__moreInfoContent",
  "popOver": "sportstrip-module-scss-module__tXyCYa__popOver",
  "showMoreArrow": "sportstrip-module-scss-module__tXyCYa__showMoreArrow",
  "singleTeam": "sportstrip-module-scss-module__tXyCYa__singleTeam",
  "strip": "sportstrip-module-scss-module__tXyCYa__strip",
  "tabletColumnLayout": "sportstrip-module-scss-module__tXyCYa__tabletColumnLayout",
  "teamLogo": "sportstrip-module-scss-module__tXyCYa__teamLogo",
  "teamName": "sportstrip-module-scss-module__tXyCYa__teamName",
  "teamNameLink": "sportstrip-module-scss-module__tXyCYa__teamNameLink",
});
